function cleanup(input:any): Record<number | string, any> {
    if (!input) return {};
    const output:any = {};
    const isObject = (obj:any) => obj !== null && typeof obj === 'object' && !Array.isArray(obj);

    Object.keys(input).forEach((key) => {
        if (input[key] && input[key].edges) {
            output[key] = input[key].edges.map((edge:any) => <Record<any, any>>cleanup(edge.node));
        } else if (isObject(input[key])) {
            output[key] = <Record<any, any>>cleanup(input[key]);
        } else if (Array.isArray(input[key])) {
            output[key] = input[key].map((item:any) => <Record<any, any>>cleanup(item));
        } else if (key !== '__typename') {
            output[key] = input[key];
        }
    });

    return output;
}

/* Pass graphql data as input */
export default function cleanGraphQLResponse(input: Record<any, any>): Record<any, any> {
    return cleanup(input);
}
